import { Notification as NotificationProps } from '@components/Notification/NotificationContext';
import { Box, IconId, Notification, Typography } from '@drone-js/core';
import { NotificationIntent } from '@drone-js/core/dist/types/components/Notification/types';
import React from 'react';
import styled from 'styled-components';

export type NotificationBadgeProps = {
    notification?: NotificationProps;
    handleDismiss?: () => void;
};

const StyledNotification = styled(Notification)<{ intent: NotificationIntent }>`
    white-space: pre-wrap;

    ${props =>
        props.intent === 'error' &&
        `
        /* Apply font weight to all text content in error notifications */
        font-weight: 600;
        
        /* Also target any nested text elements */
        * {
            font-weight: 600;
        }
    `}
`;

export const NotificationBadge: React.FC<NotificationBadgeProps> = props => {
    const { notification, handleDismiss } = props;

    const droneIconId: IconId =
        notification?.overrideIconId ||
        (notification?.color === 'error' ? 'fill.symbol.circle-close' : 'fill.symbol.circle-check');
    const intent = (): NotificationIntent => {
        switch (notification?.color) {
            case 'success':
                return 'positive';
            case 'info':
                return 'notice';
            default:
                return 'error';
        }
    };

    return (
        <>
            {notification && (
                <Box width="100%" my="12">
                    <StyledNotification
                        intent={intent()}
                        description={notification?.message}
                        asset={{
                            id: droneIconId,
                        }}
                        data-cy={notification.testId}
                        onClose={handleDismiss}
                    />
                </Box>
            )}
        </>
    );
};
